<template>
  <div class="purchaseDetails">
    <el-dialog :visible="plainGoldDialogVisible" :close-on-click-modal="false" :before-close="handleClose" center width="88%" top="5vh">
      <div class="previewWrap" v-loading="loading" element-loading-text="正在加载采购明细">
        <div class="previewTitle">采购明细表</div>

        <div class="previewMeta">
          <div class="metaItem">
            <span class="metaLabel">采购单号：</span>
            <span class="metaValue">{{ summaryInfo.orderNo }}</span>
          </div>
          <div class="metaItem">
            <span class="metaLabel">网点编码：</span>
            <span class="metaValue">{{ summaryInfo.netCode }}</span>
          </div>
          <div class="metaItem">
            <span class="metaLabel">金重合计：</span>
            <span class="metaValue">{{ summaryInfo.allGoldWeightTotal }}</span>
          </div>
          <div class="metaItem">
            <span class="metaLabel">下单人：</span>
            <span class="metaValue">{{ summaryInfo.payerName }}</span>
          </div>

          <div class="metaItem metaItem--empty"></div>
          <div class="metaItem">
            <span class="metaLabel">网点名称：</span>
            <span class="metaValue">{{ summaryInfo.netName }}</span>
          </div>
          <div class="metaItem">
            <span class="metaLabel">件数合计：</span>
            <span class="metaValue">{{ summaryInfo.allQuantityTotal }}</span>
          </div>
          <div class="metaItem">
            <span class="metaLabel">下单日期：</span>
            <span class="metaValue">{{ summaryInfo.createdTime }}</span>
          </div>

          <div class="metaItem metaItem--wide">
            <span class="metaLabel">订单备注：</span>
            <span class="metaValue">{{ summaryInfo.remark }}</span>
          </div>
          <div class="metaItem" v-if="hasPriceViewPermission()">
            <span class="metaLabel">计重加工费单价合计：</span>
            <span class="metaValue">{{ summaryInfo.allJzjgfdjbTotal }}</span>
          </div>
          <div class="metaItem" v-if="hasPriceViewPermission()">
            <span class="metaLabel">计件加工费合计：</span>
            <span class="metaValue">{{ summaryInfo.allJjjgfbTotal }}</span>
          </div>
        </div>

        <el-table
          ref="previewTable"
          :data="displayRows"
          border
          max-height="420"
          :span-method="tableSpanMethod"
          :row-class-name="tableRowClassName"
          :header-cell-style="{ textAlign: 'center' }"
          :cell-style="{ textAlign: 'center' }"
          :class="{ 'previewTable--overflow': hasTableOverflow }"
          class="previewTable"
        >
          <el-table-column label="公司款号" min-width="120">
            <template slot-scope="scope">
              {{ scope.row.displayCompanyStyleNumber }}
            </template>
          </el-table-column>
          <el-table-column label="图片" width="110">
            <template slot-scope="scope">
              <div class="goodsImageWrap">
                <el-image
                  class="goodsImage"
                  v-if="scope.row.displayImgPath"
                  :src="scope.row.displayImgPath"
                  :preview-src-list="[scope.row.displayImgPath]"
                />
                <span v-else-if="!scope.row.isSummary">-</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="货品类型" min-width="100">
            <template slot-scope="scope">
              {{ scope.row.displayGoodsType }}
            </template>
          </el-table-column>
          <el-table-column label="大类名称" min-width="120">
            <template slot-scope="scope">
              {{ scope.row.displayGeneraName }}
            </template>
          </el-table-column>
          <el-table-column label="品类名称" min-width="120">
            <template slot-scope="scope">
              {{ scope.row.displayCategoryName }}
            </template>
          </el-table-column>
          <el-table-column label="规格" min-width="80">
            <template slot-scope="scope">
              {{ scope.row.ringSize }}
            </template>
          </el-table-column>
          <el-table-column label="计重加工费单价" min-width="120" v-if="hasPriceViewPermission()">
            <template slot-scope="scope">
              {{ scope.row.displayWeightProcessingUnitPrice }}
            </template>
          </el-table-column>
          <el-table-column label="计件加工费" min-width="120" v-if="hasPriceViewPermission()">
            <template slot-scope="scope">
              {{ scope.row.displayPieceWorkFee }}
            </template>
          </el-table-column>
          <el-table-column label="件数" min-width="90">
            <template slot-scope="scope">
              {{ scope.row.displayQuantity }}
            </template>
          </el-table-column>
          <el-table-column min-width="90">
            <template slot="header">
              <span class="header-with-tip">
                <span>金重</span>
                <el-popover placement="top" title="" width="200" trigger="hover" content="注：预估金重，实际金重以结算为准">
                  <span slot="reference">
                    <svg-icon iconClass="question-mark" class="question-mark"></svg-icon>
                  </span>
                </el-popover>
              </span>
            </template>
            <template slot-scope="scope">
              {{ scope.row.displayGoldWeight }}
            </template>
          </el-table-column>
          <el-table-column label="总重量" min-width="100">
            <template slot-scope="scope">
              {{ scope.row.displayTotalWeight }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { orderDetails } from '@/api/orderApi';

export default {
  props: {
    plainGoldDialogVisible: Boolean,
    orderNo: {
      type: String,
      default: '',
    },
    orderSummary: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      hasTableOverflow: false,
      loading: false,
      detailInfo: {},
      detailList: [],
    };
  },
  computed: {
    tableRows() {
      return this.detailList.map((item) => ({
        ...item,
        displayCompanyStyleNumber: this.pickField(item, ['companyStyleNumber', 'styleNumber', 'styleNo']),
        displayImgPath: this.pickField(item, ['imgPath', 'imageUrl'], ''),
        displayGoodsType: this.pickField(item, ['goodsTypeName']),
        displayGeneraName: this.pickField(item, ['generaName', 'productName', 'bigTypeName']),
        displayCategoryName: this.pickField(item, ['productCategoryName', 'categoryName', 'smallTypeName']),
        displayWeightProcessingUnitPrice: this.pickField(item, ['jzjgfdjb']),
        displayPieceWorkFee: this.pickField(item, ['jjjgfb']),
        displayQuantity: this.pickField(item, ['quantity', 'size', 'count']),
        displayGoldWeight: this.pickField(item, ['goldWeigh', 'goldWeight', 'weight']),
        displayTotalWeight: this.pickField(item, ['totalWeight', 'grossWeight']),
      }));
    },
    summaryRow() {
      return {
        isSummary: true,
        displayCompanyStyleNumber: '合计',
        displayImgPath: '',
        displayGoodsType: '',
        displayGeneraName: '',
        displayCategoryName: '',
        displayWeightProcessingUnitPrice: this.summaryInfo.allJzjgfdjbTotal,
        displayPieceWorkFee: this.summaryInfo.allJjjgfbTotal,
        displayQuantity: this.summaryInfo.allQuantityTotal,
        displayGoldWeight: this.summaryInfo.allGoldWeightTotal,
        displayTotalWeight: this.summaryInfo.allTotalWeightTotal,
      };
    },
    displayRows() {
      return [...this.tableRows, this.summaryRow];
    },
    summaryInfo() {
      return {
        orderNo: this.resolveInfoValue(['orderNo', 'purchaseOrderNo'], this.orderNo),
        netCode: this.resolveInfoValue(['netCode', 'storeCode', 'branchCode']),
        allGoldWeightTotal: this.resolveInfoValue(['allGoldWeightTotal']),
        payerName: this.resolveInfoValue(['payerName', 'createdBy', 'orderUserName', 'submitter']),
        netName: this.resolveInfoValue(['netName', 'netAddress', 'branchName', 'storeName']),
        allQuantityTotal: this.resolveInfoValue(['allQuantityTotal']),
        createdTime: this.resolveInfoValue(['createdTime', 'createTime', 'orderTime', 'submitTime']),
        remark: this.resolveInfoValue(['remark', 'orderRemark']),
        allJzjgfdjbTotal: this.resolveInfoValue(['allJzjgfdjbTotal']),
        allJjjgfbTotal: this.resolveInfoValue(['allJjjgfbTotal']),
        allTotalWeightTotal: this.resolveInfoValue(['allTotalWeightTotal']),
      };
    },
  },
  watch: {
    orderNo: {
      immediate: true,
      handler() {
        if (this.plainGoldDialogVisible) {
          this.fetchOrderDetails();
        }
      },
    },
    plainGoldDialogVisible(val) {
      if (val) {
        this.fetchOrderDetails();
        this.$nextTick(() => {
          this.updateTableOverflow();
        });
      } else {
        this.hasTableOverflow = false;
      }
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    fetchOrderDetails() {
      if (!this.orderNo) return;

      this.loading = true;
      orderDetails({ orderNo: this.orderNo })
        .then((res) => {
          const data = res.data?.data || res.data || {};
          this.detailInfo = {
            ...this.orderSummary,
            ...data,
            ...(data.orderInfo || {}),
          };
          this.detailList = this.extractDetailList(data);
          this.$nextTick(() => {
            this.updateTableOverflow();
          });
        })
        .catch(() => {
          this.detailInfo = { ...this.orderSummary };
          this.detailList = [];
          this.$nextTick(() => {
            this.updateTableOverflow();
          });
          this.$message.error('采购明细获取失败');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    extractDetailList(data) {
      if (Array.isArray(data)) return data;
      if (Array.isArray(data.orderInfo?.detailList)) return data.orderInfo.detailList;
      if (Array.isArray(data.orderInfo?.records)) return data.orderInfo.records;
      if (Array.isArray(data.detailList)) return data.detailList;
      if (Array.isArray(data.orderInfoDetailList)) return data.orderInfoDetailList;
      if (Array.isArray(data.records)) return data.records;
      if (Array.isArray(data.list)) return data.list;
      if (Array.isArray(data.details)) return data.details;
      return [];
    },
    pickField(row, fieldList, emptyValue = '--') {
      for (let i = 0; i < fieldList.length; i++) {
        const value = row?.[fieldList[i]];
        if (value !== undefined && value !== null && value !== '') {
          return value;
        }
      }
      return emptyValue;
    },
    resolveInfoValue(fieldList, fallback = '--') {
      const mergedInfo = {
        ...this.orderSummary,
        ...this.detailInfo,
      };

      for (let i = 0; i < fieldList.length; i++) {
        const value = mergedInfo?.[fieldList[i]];
        if (value !== undefined && value !== null && value !== '') {
          return value;
        }
      }

      return fallback !== undefined && fallback !== null && fallback !== '' ? fallback : '--';
    },
    tableSpanMethod({ row, columnIndex }) {
      if (!row?.isSummary) {
        return { rowspan: 1, colspan: 1 };
      }

      if (columnIndex === 0) {
        return { rowspan: 1, colspan: 5 };
      }

      if (columnIndex > 0 && columnIndex < 5) {
        return { rowspan: 0, colspan: 0 };
      }

      return { rowspan: 1, colspan: 1 };
    },
    tableRowClassName({ row }) {
      return row?.isSummary ? 'summary-row' : '';
    },
    updateTableOverflow() {
      const tableRef = this.$refs.previewTable;
      const bodyWrapper = tableRef?.bodyWrapper || tableRef?.$el?.querySelector('.el-table__body-wrapper');

      if (!bodyWrapper) {
        this.hasTableOverflow = false;
        return;
      }

      this.hasTableOverflow = bodyWrapper.scrollHeight > bodyWrapper.clientHeight;
    },
    handleResize() {
      if (!this.plainGoldDialogVisible) return;

      this.$nextTick(() => {
        this.updateTableOverflow();
      });
    },
    handleClose() {
      this.$emit('onCloseSelectDialog');
    },
  },
};
</script>

<style scoped lang="scss">
.purchaseDetails {
  /deep/ .el-dialog {
    max-width: 1500px;
  }

  /deep/ .el-dialog__header {
    padding: 0;
  }

  /deep/ .el-dialog__body {
    padding: 20px 24px 30px;
  }

  .previewWrap {
    min-height: 420px;
    max-height: calc(90vh - 60px);
  }

  .previewTitle {
    font-size: 28px;
    font-weight: 600;
    color: #303133;
    text-align: center;
    margin-bottom: 48px;
  }

  .previewMeta {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    column-gap: 36px;
    row-gap: 28px;
    margin-bottom: 32px;
  }

  .metaItem {
    display: flex;
    align-items: flex-start;
    min-height: 24px;
    font-size: 15px;
    color: #303133;
    line-height: 24px;
  }

  .metaItem--empty {
    visibility: hidden;
  }

  .metaItem--wide {
    grid-column: span 2;
  }

  .metaLabel {
    flex-shrink: 0;
  }

  .metaValue {
    flex: 1;
    word-break: break-all;
  }

  .header-with-tip {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .question-mark {
    width: 16px;
    height: 16px;
    margin-left: 3px;
    cursor: pointer;
  }

  .previewTable {
    /deep/ .el-table__body-wrapper {
      overflow-y: auto;
    }

    /deep/ th,
    /deep/ td {
      padding: 10px 0;
    }

    &.previewTable--overflow /deep/ .summary-row td {
      position: sticky;
      bottom: 0;
      z-index: 3;
      background: #fff;
      border-top: 1px solid #ebeef5;
      border-right: 1px solid #ebeef5;
      box-shadow: inset 0 -1px 0 #ebeef5;
    }

    /deep/ .summary-row td .cell {
      text-align: center;
      font-weight: 500;
    }
  }

  .goodsImageWrap {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 52px;
  }

  .goodsImage {
    width: 48px;
    height: 48px;
    object-fit: cover;
    border-radius: 4px;
  }
}
</style>
